import { render, staticRenderFns } from "./thirdPartyList.vue?vue&type=template&id=8af2567c&"
import script from "./thirdPartyList.vue?vue&type=script&lang=js&"
export * from "./thirdPartyList.vue?vue&type=script&lang=js&"
import style0 from "./thirdPartyList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports